<template>
  <div class="section-contact" id="section-contact">
    <div-columns column-num="is-8">
      <form-dynamix type="team" :feedback="feedback" :loading="loading"
        :names="names" :models="models" :attributes="attributes"
        :vuelidate="$v"
        :no-print="noPrint"
        :is-print="isPrint"
        :is-print-pdf="isPrintPdf"
        :is-rerender="isRerender"
        @recaptcha="onRecaptcha"
        @send="onSend">
      </form-dynamix>
    </div-columns>
  </div>
</template>

<script type="text/javascript">
import EventBus from '@/controllers/EventBus'
import FormDynamix from '@/components/FormDynamix'
import DivColumns from '@/components/DivColumns'
import { validationMixin } from 'vuelidate'
import { required, numeric, email, minLength } from 'vuelidate/lib/validators'
import Singulo from '@/apis/Singulo'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'contactsection',
  mixins: [validationMixin],
  components: {
    DivColumns,
    FormDynamix,
    VueRecaptcha
  },
  data: function () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      noPrint: true,
      isPrint: false,
      isPrintPdf: false,
      isRerender: false,
      // captcha: '',
      // session: '',
      // captchaImage: undefined,
      recaptcha: undefined,
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      names: [
        'name',
        'lname',
        'business',
        'phone',
        'email',
        'message'
      ],
      models: {
        recaptcha: undefined,
        name: '',
        lname: '',
        business: '',
        phone: '',
        email: '',
        message: ''
      },
      attributes: {
        name: {
          title: 'First Name',
          column: 'is-6'
        },
        lname: {
          title: 'Last Name',
          column: 'is-6'
        },
        business: {
          title: 'Business Name (optional)'
        },
        phone: {
          title: 'Phone Number',
          column: 'is-6'
        },
        email: {
          title: 'Email',
          column: 'is-6'
        },
        message: {
          type: 'textarea',
          title: 'Message',
          curLength: 0,
          maxLength: 500
        }
      },
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      loading: false,
      navEmail: EventBus._data._navEmail
    }
  },
  validations: {
    models: {
      recaptcha: { required },
      name: { required },
      lname: { required },
      business: {},
      phone: { required, numeric },
      email: { required, email, minLength: minLength(4) },
      message: { required }
    }
  },
  mounted: function () {
    // on event resize
    this.isDesktop = (window.innerWidth >= 768)
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = (event.target.innerWidth >= 768)
    }.bind(this))
  },
  methods: {
    onRecaptcha: function (info) {
      console.log('recaptcha')
      console.log(info)
      if (info && info.status) {
        this.models.recaptcha = (info.status === 'ok' ? info.response : undefined)
        if (info.status !== 'ok') {
          // console.log('FormDynamix:recaptcha():' + info.status)
        }
      }
    },

    onClear: function () {
      this.isRerender = true
      this.models.recaptcha = undefined

      this.models.name = ''
      this.models.lname = ''
      this.models.business = ''
      this.models.phone = ''
      this.models.email = ''
      this.models.message = ''

      this.$nextTick(function () {
        this.isRerender = false
      })
    },

    onSend: function (formInfo) {
      // $v.models.$touch()
      var _self = this
      // console.log('ContactSection:onSend(): $v / models')
      // console.log(formInfo)

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return
      }

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.'
        return
      }
      _self.feedback = false

      var models = formInfo.models

      // console.log('-- send form --')
      // console.log(models)
      // console.log(models.name)
      // console.log(models.lname)
      // console.log(models.business)
      // console.log(models.phone)
      // console.log(models.email)
      // console.log(models.message)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true
      Singulo.email(
        'contact',
        models.recaptcha,
        models.name,
        models.lname,
        models.business,
        models.phone,
        models.email,
        models.message
      )
      .then(data => {
        _self.loading = false

        if (!data || (data && data.status !== 'ok')) {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
          return
        }

        this.$v.models.$reset()
        this.onClear()

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        _self.$toast.open({
          message: 'Your request has been successfully submitted. Thank you for your enquiry.',
          position: 'is-bottom',
          type: 'is-success'
        })
        _self.feedback = 'Your request has been successfully submitted. Thank you for your enquiry.'
      })
      .catch(error => {
        // this.error = error.error
        // console.log(error)
        // _self.captcha = ''

        // invalid validate
        if (error && error.status === 'invalid_validate') {
          _self.feedback = 'Invalid data, please recheck input.'
          _self.loading = false
          return
        }

        // invalid recaptcha
        if (error && error.status === 'invalid_recaptcha') {
          _self.feedback = 'Invalid recaptcha, please kindly refresh and try again.'
          _self.loading = false
          return
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
        _self.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-contact {
  // padding: 1rem 0;
  padding: 3em 0.75rem;
  background-color: $color-blue;

  @media screen and (min-width: $desktop) {
    padding: 5em 0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// ContactSection.vue?3eb164a4